import { styled } from '../../lib/stitches'
import { SIDE_DRAWER_WIDTH } from '../studio/Studio'

const Container = styled('div', {
  height: '100vh',
  background: 'var(--gray-9)',
  borderLeft: '1px solid var(--gray-7)',
  zIndex: '3',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  color: 'var(--gray-1)'
})

const Header = {
  Content: styled('div', {
    padding: '14px 16px',
    borderBottom: '1px solid var(--gray-7)'
  }),
  Title: styled('h1', {
    marginBottom: '4px',
    fontSize: '20px',
    lineHeight: '24px',
    fontWeight: 600
  }),
  Subtitle: styled('h2', {
    marginBottom: '1px',
    fontSize: '12px',
    lineHeight: '12px',
    opacity: 0.6,
    fontWeight: 400
  })
}

const Content = styled('div', {
  flex: '1',
  padding: '16px',
  overflow: 'hidden'
})

const StudioSideDrawer = ({ content }) => {
  return (
    <Container
      css={{
        visibility: content ? 'visible' : 'hidden',
        width: content ? SIDE_DRAWER_WIDTH : '0px'
      }}
    >
      <Header.Content>
        <Header.Title>Arpeggi Studio</Header.Title>
        <Header.Subtitle>Version 2.0</Header.Subtitle>
      </Header.Content>
      <Content>{content}</Content>
    </Container>
  )
}

export default StudioSideDrawer
